import { render } from "./MapBox.vue?vue&type=template&id=b4fc5320"
const script = {}

import exportComponent from "/Applications/MAMP/htdocs/adriengeoorge.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__